import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { wordTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.word";
import { index, integer, real } from "@-/dev.improve.haniverse.lib.database.table";

export const wordBiauTable = staticTable(
  "word_biau",
  {
    wordId: integer("word_id")
      .notNull()
      .references(() => wordTable.id),

    /** Rank as recorded in BIAU2.TXT (詞頻總表) — 1-based, from source row order. */
    rank: integer("rank").notNull(),

    /** Raw occurrence count in the BIAU sample corpus. */
    frequency: integer("frequency").notNull(),

    /** Running sum of frequency up to and including this row. */
    cumulativeFrequency: integer("cumulative_frequency").notNull(),

    /** Running cumulative coverage as a percent (0–100). */
    cumulativePercent: real("cumulative_percent").notNull(),
  },
  (table) => [
    index("word_biau_word_id_idx").on(table.wordId),
    index("word_biau_rank_idx").on(table.rank),
  ],
);

export type WordBiau = typeof wordBiauTable.$inferSelect;
